import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NotInput } from '@nebalkon-workspace/ui-kit';
import { CabinetButtonComponent } from '@nebalkon-workspace/cabinet-client';
import { StaffOrderDetailFacade } from './staff-order-detail.facade';

@Component({
  selector: 'lib-staff-order-detail-mover-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, FormsModule, CabinetButtonComponent, NotInput],
  templateUrl: './staff-order-detail-mover-panel.component.html',
  styleUrl: './staff-order-detail-panels.component.scss',
})
export class StaffOrderDetailMoverPanelComponent {
  readonly facade = inject(StaffOrderDetailFacade);
}
